import React from "react";
import { Box, Typography, Container, Link, Button } from "@mui/material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import useTranslation from "../customHooks/translations";
import { DEFAULT_THEME_COLOR, DEFAULT_GRADIENT, DEFAULT_GRADIENT_HOVER } from "../constants/theme";

const GetFullAccessComponent = props => {
  const translation = useTranslation();

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 4,
          p: 4,
          borderRadius: 3,
          background: 'linear-gradient(135deg, #0d1b2a 0%, #0d3d2e 100%)',
          border: '1px solid rgba(255,255,255,0.12)',
          textAlign: 'center',
        }}
      >
        <LockOpenIcon sx={{ fontSize: 48, color: DEFAULT_THEME_COLOR, mb: 2 }} />
        <Typography variant="h5" fontWeight="bold" gutterBottom sx={{ color: 'white' }}>
          {translation.freakPlaces.restrictedView}
        </Typography>
        <Typography variant="body1" gutterBottom sx={{ color: 'rgba(255,255,255,0.65)', mb: 3 }}>
          {translation.freakPlaces.restrictedView2}
        </Typography>
        <Button
          variant="contained"
          href="/register"
          sx={{
            background: DEFAULT_GRADIENT,
            color: 'white',
            fontWeight: 700,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            fontSize: '1rem',
            boxShadow: '0 4px 16px rgba(54,201,162,0.35)',
            '&:hover': { background: DEFAULT_GRADIENT_HOVER },
            mb: 2,
          }}
        >
          Register for Free
        </Button>
        <Box mt={1}>
          <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.45)' }}>
            {translation.freakPlaces.restrictedView3}{' '}
            <Link href="/login" underline="hover" sx={{ color: DEFAULT_THEME_COLOR }}>
              Login
            </Link>
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default GetFullAccessComponent;
